'use client';

import React from 'react';
import { QueryProvider } from '@/providers/QueryProvider';
import { SSDesignSystemProvider } from '@skin-seoul/design-system';
import { OverlayProvider } from '@/providers/OverlayProvider';
import { CartDrawerContextProvider } from '@skin-seoul/shared-components';
import { LoggerProvider, PageLogger, gtmEventSender } from '@/utils/logger';
import { Toaster } from '@skin-seoul/design-system';
import { env } from '@/utils/env';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { Country } from '@skin-seoul/service';
import { WishlistCustomerKeyProvider, RegionCurrencyContextProvider, CartSessionKeyProvider, UserLoggedInKeyProvider } from '@skin-seoul/service';
import CurrencyUpdateBackdrop from '@/components/ui/CurrencyUpdateBackdrop';
import { IsWebviewProvider } from './IsWebviewProvider';
import { CartInvalidationBridge } from './CartInvalidationBridge';
import { CookieConsentProvider } from './CookieConsentProvider';
interface AppProvidersProps {
  children: React.ReactNode;
  initialCountry?: Country;
  isWebView: boolean;
}
export default function AppProviders({
  children,
  initialCountry,
  isWebView
}: AppProvidersProps) {
  const isDebugMode = !(env('NEXT_PUBLIC_ENV') === 'PROD' || env('NEXT_PUBLIC_ENV') === 'STAGING' || env('NEXT_PUBLIC_ENV') === 'DEV');
  return <SSDesignSystemProvider data-sentry-element="SSDesignSystemProvider" data-sentry-component="AppProviders" data-sentry-source-file="AppProviders.tsx">
      <QueryProvider data-sentry-element="QueryProvider" data-sentry-source-file="AppProviders.tsx">
        {isWebView && <CartInvalidationBridge />}
        <IsWebviewProvider isWebView={isWebView} data-sentry-element="IsWebviewProvider" data-sentry-source-file="AppProviders.tsx">
          <LoggerProvider appName="SkinSeoul" debug={isDebugMode} eventLogger={gtmEventSender} data-sentry-element="LoggerProvider" data-sentry-source-file="AppProviders.tsx">
            <PageLogger data-sentry-element="PageLogger" data-sentry-source-file="AppProviders.tsx">
              <RegionCurrencyContextProvider initialCountry={initialCountry} data-sentry-element="RegionCurrencyContextProvider" data-sentry-source-file="AppProviders.tsx">
                <CookieConsentProvider data-sentry-element="CookieConsentProvider" data-sentry-source-file="AppProviders.tsx">
                  <UserLoggedInKeyProvider data-sentry-element="UserLoggedInKeyProvider" data-sentry-source-file="AppProviders.tsx">
                    <CartSessionKeyProvider data-sentry-element="CartSessionKeyProvider" data-sentry-source-file="AppProviders.tsx">
                      <CartDrawerContextProvider data-sentry-element="CartDrawerContextProvider" data-sentry-source-file="AppProviders.tsx">
                        <WishlistCustomerKeyProvider data-sentry-element="WishlistCustomerKeyProvider" data-sentry-source-file="AppProviders.tsx">
                          <OverlayProvider data-sentry-element="OverlayProvider" data-sentry-source-file="AppProviders.tsx">
                            <Toaster data-sentry-element="Toaster" data-sentry-source-file="AppProviders.tsx" />
                            <CurrencyUpdateBackdrop data-sentry-element="CurrencyUpdateBackdrop" data-sentry-source-file="AppProviders.tsx" />
                            {children}
                          </OverlayProvider>
                          <ReactQueryDevtools initialIsOpen={false} data-sentry-element="ReactQueryDevtools" data-sentry-source-file="AppProviders.tsx" />
                        </WishlistCustomerKeyProvider>
                      </CartDrawerContextProvider>
                    </CartSessionKeyProvider>
                  </UserLoggedInKeyProvider>
                </CookieConsentProvider>
              </RegionCurrencyContextProvider>
            </PageLogger>
          </LoggerProvider>
        </IsWebviewProvider>
      </QueryProvider>
    </SSDesignSystemProvider>;
}